export const BLOG_PAGE_SIZE = 6;

export function paginateBlogPosts<T>(posts: T[], page: number) {
  const totalPages = Math.max(1, Math.ceil(posts.length / BLOG_PAGE_SIZE));
  const currentPage = Math.min(Math.max(1, page), totalPages);
  return {
    currentPage,
    totalPages,
    posts: posts.slice((currentPage - 1) * BLOG_PAGE_SIZE, currentPage * BLOG_PAGE_SIZE),
  };
}

export function blogPageNumbers(currentPage: number, totalPages: number): (number | "ellipsis")[] {
  const pages = Array.from({ length: totalPages }, (_, index) => index + 1)
    .filter((page) => page === 1 || page === totalPages || Math.abs(page - currentPage) <= 1 || page <= 3 && currentPage <= 2);
  return pages.flatMap((page, index) => index > 0 && page - pages[index - 1] > 1 ? ["ellipsis", page] : [page]);
}